import React, { useState, useEffect, useCallback } from "react";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { API } from 'aws-amplify';
import './SafetyScore.scss';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const SafetyScore = (props) => {
    const {
        asset,
        dateSel,
        dateSelTo,
        timeFrom,
        timeTo,
        counts,
        formatDate,
        avg_excluding_zeros,
        safetyScore,
        setSafetyScore,
        speedUnit
     } = props

    const [prevSafetyScore, setPrevSafetyScore] = useState([]);
    const [showSafetyScore, setShowSafetyScore] = useState([]);
    const [distanceMeasure, setDistanceMeasure] = useState(3);
    const [speedMeasure, setSpeedMeasure] = useState(2);
    const [cyclistFactorPercentage, setCyclistFactorPercentage] = useState(20);
    const [pedestrianFactorPercentage, setPedestrianFactorPercentage] = useState(30);
    const [distanceFactorPercentage, setDistanceFactorPercentage] = useState(10);
    const [speedFactorPercentage, setSpeedFactorPercentage] = useState(50);
    const [extraColumns, setExtraColumns] = useState(false);

    const percentil_85 = useCallback((arr) => {
        if (!Array.isArray(arr) || arr.length === 0) {
            return 0;
        }

        // Step 1: Sort the array in ascending order
        arr.sort((a, b) => a - b);
        // Step 2: Calculate the index of the 85th percentile value
        const index = Math.ceil(0.85 * arr.length) - 1;
        // Step 3: Retrieve the value at that index
        return parseFloat(arr[index]).toFixed(2);
    },[]);

    const resetValues = () => {
        setDistanceMeasure(3);
        setSpeedMeasure(2);
        setCyclistFactorPercentage(20);
        setPedestrianFactorPercentage(30);
        setDistanceFactorPercentage(10);
        setSpeedFactorPercentage(50);
        setExtraColumns(false);
    }

    // SPEED START
    useEffect(() => {

        // SafetyScore
        const getSafetyScore = () => {
            let arr = [];

            let speed_unit = 1
            switch (speedUnit){
                case 'ms':
                    speed_unit = 3.6
                    break;
                case 'mph':
                    speed_unit = 1.60934
                    break;
                default:
                    speed_unit = 1
            }

            //Filter Vehicles SPEED. Exclude PEDESTRIANS
            for (let i = 0; i < counts.length; i++){
                const arrSpeed = counts[i].entries
                    .map(obj => {return { 
                        date_iso: counts[i].date_iso,
                        SPEED: obj.SPEED * speed_unit,
                        GAP: obj.GAP || 0,
                        HEADWAY: obj.HEADWAY || 0,
                        CLASS: obj.CLASS}})
                    .filter(item => {return item.CLASS !== 'PEDESTRIAN' && item.CLASS !== 'BIKE'})

                let pedestrianCount = counts[i].entries
                    .filter(item => item.CLASS === 'PEDESTRIAN')
                    .reduce((acc, item) => acc + (item.VOLUME || 0), 0);
                let bikeCount = counts[i].entries
                    .filter(item => item.CLASS === 'BIKE')
                    .reduce((acc, item) => acc + (item.VOLUME || 0), 0);
                let totalCount = counts[i].entries
                    .reduce((acc, item) => acc + (item.VOLUME || 0), 0);
                let avg = {}
                if (arrSpeed.length > 0)
                    avg = {
                        date_iso: arrSpeed[0].date_iso,
                        SPEED: avg_excluding_zeros(arrSpeed.map(i => i.SPEED)),
                        GAP: avg_excluding_zeros(arrSpeed.map(i => i.GAP)),
                        HEADWAY: avg_excluding_zeros(arrSpeed.map(i => i.HEADWAY)),
                        COUNT_PEDESTRIAN: pedestrianCount,
                        COUNT_BIKE: bikeCount,
                        COUNT_TOTAL: totalCount
                    } 

                if (avg.SPEED)
                    arr = [...arr, avg];
            }
            setPrevSafetyScore(arr);
        }

        getSafetyScore();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts, avg_excluding_zeros, setSafetyScore]);
    // SPEED END

    useEffect(() => {
        const getAvgSpeed = async () => {
            const dtF = new Date(dateSel)
            const dtT = new Date(dateSelTo)

            const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

            const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();
            
            const filter = asset +'?start='+ dateStart +'&end='+ dateEnd +'&class=ALL'// + vehClass
        
            // HOURLY COUNT
            await API.get('hourly_counts_speed','/'+ filter, params)
            .then(resp => {

                let arrByHour = [];
                let arrByHourV85 = [];

                let speed_unit = 1
                switch (speedUnit){
                    case 'ms':
                        speed_unit = 3.6
                        break;
                    case 'mph':
                        speed_unit = 1.60934
                        break;
                    default:
                        speed_unit = 1
                }

                //Filter Vehicles SPEED. Exclude PEDESTRIANS
                for (let i = 0; i < resp.length; i++){
                                
                    let arrSpeed = resp[i]
                    arrSpeed.SPEED = parseFloat(arrSpeed.SPEED * speed_unit).toFixed(2)
                    arrSpeed.P85_SPEED = parseFloat(arrSpeed.P85_SPEED * speed_unit).toFixed(2)

                    let avg = {}
                    let v85 = {}

                    if (arrSpeed.SPEED > 0){
                        // AVG SPEED / HOUR
                        avg = {
                            date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[4]) 
                            + ' - ' + moment(new Date(arrSpeed.date_iso)).add(1, 'hour').format(formatDate[4]),
                            // SPEED: avg_excluding_zeros(arrSpeed.map(i => i.SPEED))
                            SPEED: arrSpeed.SPEED
                        } 

                        // V85 SPEED / HOUR
                        v85 = {
                            date_iso: moment(new Date(arrSpeed.date_iso)).format(formatDate[4]) 
                            + ' - ' + moment(new Date(arrSpeed.date_iso)).add(1, 'hour').format(formatDate[4]),
                            // SPEED: percentil_85(arrSpeed.map(i => i.SPEED))
                            SPEED: arrSpeed.P85_SPEED
                        } 

                    }

                    if (avg.SPEED)
                        arrByHour = [...arrByHour, avg];

                    if (v85.SPEED)
                        arrByHourV85 = [...arrByHourV85, v85];
                }

                // SPEED VS TIME - START
                // array by hour 
                const hh = [...new Set(arrByHour.map(item => item.date_iso))];
                
                let groupByHour = []
                hh.map(item => {
                    // return groupByHour.push({date: item, speed: avg_excluding_zeros(arrByHour.filter(i => i.date_iso === item).map(i => i.SPEED)) })
                    return groupByHour.push({date: item, speed: avg_excluding_zeros(arrByHour.filter(i => i.date_iso === item).map(i => parseFloat(i.SPEED))) })
                })
        
                groupByHour = groupByHour.sort((a, b) => (a.date > b.date) ? 1 : -1)

                // const avg = {
                //     labels: groupByHour.map(i => i.date),
                //     datasets: [{
                //         type: 'line',
                //         label: 'Average Speed',
                //         data: groupByHour.map(i => i.speed),
                //         borderColor: [chartColors[10]],
                //         backgroundColor: [hex2rgba(chartColors[10], 0.7)],
                //         borderWidth: 2,
                //         datalabels: {
                //             display: false
                //         }
                //     },
                //     ]
                // }
                // setSpeedTime(avg);
                // setSpeedTimeTbl(groupByHour);
                // SPEED VS TIME - END

                // SPEED V85 HOUR - START
                // array by hour v85
                const hhv85 = [...new Set(arrByHourV85.map(item => item.date_iso))];

                let groupByHourV85 = []
                hhv85.map(item => {
                    return groupByHourV85.push({date: item, speed: percentil_85(arrByHourV85.filter(i => i.date_iso === item).map(i => parseFloat(i.SPEED))) })
                })

                const updatedSafetyScore = prevSafetyScore.map((item, index) => ({
                    ...item,
                    SPEED_2: groupByHour[index] ? parseFloat(groupByHour[index].speed) : null,
                    SPEED_85: groupByHourV85[index] ? parseFloat(groupByHourV85[index].speed) : null
                }));

                setSafetyScore(updatedSafetyScore);

                // const v85 = {
                //     labels: groupByHourV85.map(i => i.date),
                //     datasets: [{
                //         type: 'line',
                //         label: 'Percentil 85',
                //         data: groupByHourV85.map(i => i.speed),
                //         borderColor: [chartColors[1]],
                //         backgroundColor: [hex2rgba(chartColors[1], 0.7)],
                //         borderWidth: 2,
                //         datalabels: {
                //             display: false
                //         }
                //     },
                //     ]
                // }
                // setSpeedV85(v85);
                // setSpeedV85Tbl(groupByHourV85);
                // SPEED V85 HOUR - ENd

            })
        }

        getAvgSpeed();
    }, [prevSafetyScore])

    useEffect(() => {
        const updatedSafetyScore = safetyScore.map((item, index) => {

            const UPDATED_HEADWAY = item.GAP / 12;

            const SPEED_METRIC = speedMeasure === 1 ? item.SPEED : item.SPEED_85;
            const DISTANCE_METRIC = distanceMeasure === 1 ? item.GAP : distanceMeasure === 2 ? item.HEADWAY : UPDATED_HEADWAY;

            const VELOCITY = SPEED_METRIC && (SPEED_METRIC * 1000 / 3600);
            const DIST_HEAD = VELOCITY * DISTANCE_METRIC;
            const RSA_SD = ((VELOCITY * (1/3) / 100 )* (VELOCITY * (100/3) / 100)) * 102;
            const SECONDS = RSA_SD / VELOCITY;
            const CYC_PER = item.COUNT_BIKE / item.COUNT_TOTAL;
            const CYC_FACTOR = CYC_PER * 500;
            const PED_PER = item.COUNT_PEDESTRIAN / item.COUNT_TOTAL;
            const PED_FACTOR = PED_PER * 500;
            const DIST_COEF = DIST_HEAD / RSA_SD;
            const DIST_FACTOR = (200 - DIST_COEF) / 2;
            const LIMIT = 30;
            const SPEED_GAP = LIMIT - SPEED_METRIC;
            const SPEED_FACTOR = 100 - SPEED_GAP;
            const SAFETY_SCORE = (SPEED_FACTOR * speedFactorPercentage) + (DIST_FACTOR * distanceFactorPercentage) + (PED_FACTOR * pedestrianFactorPercentage) + (CYC_FACTOR * cyclistFactorPercentage);
            const MARK = SAFETY_SCORE / 1000;

            let FINAL_MARK;
            if (MARK >= 9) {
                FINAL_MARK = {value: 'F', color: 'red'}
            } else if (MARK >= 8) {
                FINAL_MARK = {value: 'E', color: 'orange'}
            } else if (MARK >= 7) {
                FINAL_MARK = {value: 'D', color: 'orange'}
            } else if (MARK >= 6) {
                FINAL_MARK = {value: 'C', color: 'green'}
            } else if (MARK >= 5) {
                FINAL_MARK = {value: 'B', color: 'green'}
            } else {
                FINAL_MARK = {value: 'A', color: 'green'}
            }


            return {
                ...item,
                UPDATED_HEADWAY,
                VELOCITY,
                DIST_HEAD,
                RSA_SD,
                SECONDS,
                CYC_PER,
                CYC_FACTOR,
                PED_PER,
                PED_FACTOR,
                DIST_COEF,
                DIST_FACTOR,
                LIMIT,
                SPEED_GAP,
                SPEED_FACTOR,
                SAFETY_SCORE,
                MARK,
                FINAL_MARK
            };
        });

        setShowSafetyScore(updatedSafetyScore);
    }, [safetyScore, speedMeasure, distanceMeasure, cyclistFactorPercentage, pedestrianFactorPercentage, distanceFactorPercentage, speedFactorPercentage])


    return (
        <div className="row p-2">
            <div className="col-md-12">
                <h2 className="text-header">(Beta) Safety Score</h2>
                <div className="text-description small pb-3">
                Safety Score per hour
                </div>
                <div className="row">

                    <div className="col-md-12">
                    <Table responsive hover className="small p-0 border">
                    <thead>
                        <tr>
                        <th className="table-th-det">Date</th>
                        <th className="table-th-det">Time</th>
                        <th className="table-th-det">Volume</th>
                        <th className={"table-th-det " + (speedMeasure === 1 ? '' : !extraColumns ? 'hide-columns' : '')}>Speed [km/h]</th>
                        {/* <th className="table-th-det">Speed 2 [km/h]</th> */}
                        <th className={"table-th-det " + (speedMeasure === 2 ? '' : !extraColumns ? 'hide-columns' : '')}>Speed V85 [km/h]</th>
                        <th className={"table-th-det " + (distanceMeasure === 1 ? '' : !extraColumns ? 'hide-columns' : '')}>Gap [s]</th>
                        <th className={"table-th-det " + (distanceMeasure === 2 ? '' : !extraColumns ? 'hide-columns' : '')}>Headway [s]</th>
                        <th className={"table-th-det " + (distanceMeasure === 3 ? '' : !extraColumns ? 'hide-columns' : '')}>Updated Headway [s]</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Velocity [m/s]</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Dist Head [m]</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>RSA SD</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Seconds</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Cyclist</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Cyc %</th>
                        <th className="table-th-det">Cyc Factor</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Pedestrian</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Ped %</th>
                        <th className="table-th-det">Ped Factor</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Dist Coef</th>
                        <th className="table-th-det">Dist Factor</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Limit</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Speed Gap</th>
                        <th className="table-th-det">Speed Factor</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Safety Score</th>
                        <th className={"table-th-det " + (!extraColumns ? 'hide-columns' : '')}>Mark</th>
                        <th className="table-th-det">Final Mark</th>
                        </tr>
                    </thead>
                    <tbody>

                    {showSafetyScore.map((x, i) =>
                    <tr key={i} className="table-tr">
                        <td className="table-td">{ moment.utc(x.date_iso).local().format(formatDate[0])}</td>
                        <td className="table-td">{
                        parseInt(moment.utc(x.date_iso).local().format('HH'))+":00 - "
                        + (parseInt(moment.utc(x.date_iso).local().format('HH'))+1)+":00"
                        }</td>
                        <td className="table-td main-attributes-table">{x.COUNT_TOTAL}</td>
                        <td className={"table-td " + (speedMeasure === 1 ? 'main-attributes-table' : !extraColumns ? 'hide-columns' : '')}>{parseFloat(x.SPEED).toFixed(2)}</td>
                        {/* <td className="table-td">{x.SPEED_2 && parseFloat(x.SPEED_2).toFixed(2)}</td> */}
                        <td className={"table-td " + (speedMeasure === 2 ? 'main-attributes-table' : !extraColumns ? 'hide-columns' : '')}>{parseFloat(x.SPEED_85).toFixed(2)}</td>
                        <td className={"table-td " + (distanceMeasure === 1 ? 'main-attributes-table' : !extraColumns ? 'hide-columns' : '')}>{parseFloat(x.GAP).toFixed(2)}</td>
                        <td className={"table-td " + (distanceMeasure === 2 ? 'main-attributes-table' : !extraColumns ? 'hide-columns' : '')}>{parseFloat(x.HEADWAY).toFixed(2)}</td>
                        <td className={"table-td " + (distanceMeasure === 3 ? 'main-attributes-table' : !extraColumns ? 'hide-columns' : '')}>{parseFloat(x.UPDATED_HEADWAY).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.VELOCITY).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.DIST_HEAD).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.RSA_SD).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.SECONDS).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{x.COUNT_BIKE}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.CYC_PER).toFixed(2)}</td>
                        <td className="table-td factor-attributes-table">{parseFloat(x.CYC_FACTOR).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{x.COUNT_PEDESTRIAN}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.PED_PER).toFixed(2)}</td>
                        <td className="table-td factor-attributes-table">{parseFloat(x.PED_FACTOR).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.DIST_COEF).toFixed(2)}</td>
                        <td className="table-td factor-attributes-table">{parseFloat(x.DIST_FACTOR).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{x.LIMIT}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.SPEED_GAP).toFixed(2)}</td>
                        <td className="table-td factor-attributes-table">{parseFloat(x.SPEED_FACTOR).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')}>{parseFloat(x.SAFETY_SCORE).toFixed(2)}</td>
                        <td className={"table-td " + (!extraColumns ? 'hide-columns' : '')} style={{ backgroundColor: x.MARK >= 8 ? 'red' : x.MARK >= 7 ? 'orange' : 'green' }}>{parseFloat(x.MARK).toFixed(2)}</td>
                        <td className="table-td" style={{ backgroundColor: x.FINAL_MARK.color }}>{x.FINAL_MARK.value}</td>
                    </tr>
                    )}

                    </tbody>
                    </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <Form.Group controlId="distanceMeasure">
                            <Form.Label>Distance measure</Form.Label>
                            <Form.Control
                                as="select"
                                value={distanceMeasure}
                                onChange={e => {setDistanceMeasure(parseInt(e.target.value))}}>
                                    <option key={1} value={1}>Gap [s]</option>
                                    <option key={2} value={2}>Headway [s]</option>
                                    <option key={3} value={3}>Updated Headway [s]</option>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Form.Group controlId="speedMeasure">
                            <Form.Label>Speed measure</Form.Label>
                            <Form.Control
                                as="select"
                                value={speedMeasure}
                                onChange={e => {setSpeedMeasure(parseInt(e.target.value))}}>
                                    <option key={1} value={1}>Speed [km/h]</option>
                                    <option key={2} value={2}>Speed V85 [km/h]</option>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Form.Group controlId="cyclistFactorPer">
                            <Form.Label>Cyclist factor %</Form.Label>
                            <Form.Control
                                type="number"
                                value={cyclistFactorPercentage}
                                onChange={e => {setCyclistFactorPercentage(parseInt(e.target.value))}}>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Form.Group controlId="pedestrianFactorPer">
                            <Form.Label>Pedestrian factor %</Form.Label>
                            <Form.Control
                                type="number"
                                value={pedestrianFactorPercentage}
                                onChange={e => {setPedestrianFactorPercentage(parseInt(e.target.value))}}>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Form.Group controlId="distanceFactorPer">
                            <Form.Label>Distance factor %</Form.Label>
                            <Form.Control
                                type="number"
                                value={distanceFactorPercentage}
                                onChange={e => {setDistanceFactorPercentage(parseInt(e.target.value))}}>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Form.Group controlId="speedFactorPer">
                            <Form.Label>Speed factor %</Form.Label>
                            <Form.Control
                                type="number"
                                value={speedFactorPercentage}
                                onChange={e => {setSpeedFactorPercentage(parseInt(e.target.value))}}>
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="col-md-2">
                        <Button variant="info" size="sm" onClick={() => setExtraColumns(!extraColumns)} className="mr-1 text-nowrap">
                            {extraColumns ? 'Hide extra columns' : 'Show extra columns'}
                        </Button>
                    </div>
                    <div className="col-md-2">
                        <Button variant="light" size="sm" onClick={() => resetValues()} className="mr-1 text-nowrap">
                            Reset values
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SafetyScore;